import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function MetaAdsPage() {
  return <ServiceDetailLayout slug="meta-ads" />;
}
